import { createShouldForwardPropBlockList } from "../utils/helper";
import { Wrapper as ButtonWrapper } from "../button/button.styles";
import styled from "styled-components";
import { type SliderProps } from "./slider";

type ScrollContainerInnerProps = Pick<SliderProps, "spaceBetween" | "space">;

type NavigationButtonProps = {
    direction: "prev" | "next";
    disabled: boolean;
};

type BulletProps = {
    active: boolean;
};

export const Wrapper = styled("div")(() => ({
    position: "relative",
}));

export const Content = styled("div")(() => ({
    position: "relative",
}));

export const ScrollContainer = styled("div")(() => ({
    position: "relative",
}));

export const ScrollContainerInner = styled("div").withConfig({
    shouldForwardProp: createShouldForwardPropBlockList(["spaceBetween", "space"]),
})<ScrollContainerInnerProps>(({ spaceBetween = 0, space }) => ({
    display: "flex",
    alignItems: "flex-start",
    ...(spaceBetween && { columnGap: `${spaceBetween}px` }),
    ...(space && { padding: `${space}px`, margin: `-${space}px` }),
}));

export const NavigationButton = styled("div").withConfig({
    shouldForwardProp: createShouldForwardPropBlockList(["direction", "disabled"]),
})<NavigationButtonProps>(({ direction, disabled, theme }) => ({
    position: "absolute",
    top: "50%",
    transitionProperty: "opacity",
    transitionDuration: "300ms",
    transitionTimingFunction: theme.transitionTimingFunction["out-cubic"],
    ...(direction === "prev" && {
        left: 0,
        translate: "-50% -50%",
    }),
    ...(direction === "next" && {
        right: 0,
        translate: "50% -50%",
    }),
    [`${ButtonWrapper}`]: {
        ...(direction === "prev" && {
            rotate: "180deg",
        }),
    },
    ...(disabled && {
        opacity: 0,
        pointerEvents: "none",
    }),
}));

export const Bullets = styled("div")(() => ({
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
}));

export const Bullet = styled("div").withConfig({
    shouldForwardProp: createShouldForwardPropBlockList(["active"]),
})<BulletProps>(({ active, theme }) => ({
    width: theme.spacing[5],
    height: theme.spacing[5],
    marginTop: theme.spacing[4],
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:only-child": {
        display: "none",
    },
    "& span": {
        display: "block",
        borderRadius: theme.borderRadius.full,
        width: theme.spacing[3],
        height: theme.spacing[3],
        transitionProperty: "background-color, border-color, color",
        transitionDuration: "300ms",
        transitionTimingFunction: theme.transitionTimingFunction["out-cubic"],
        backgroundColor: active ? theme.colors.gray[950] : theme.colors.gray[200],
    },
}));
